"use client";

import dynamic from "next/dynamic";
export const PaymentFeedback = dynamic(
  () =>
    import("@components/Payment/Feedback/PaymentFeedback").then(
      (m) => m.PaymentFeedback,
    ),
  { ssr: false },
);
